export default '/build/a4d71fcb.jpg'